import * as Yup from 'yup';

export const beneficiaryScheme = Yup.object().shape({
  firstName: Yup.string().required('Required Field'),
  middleName: Yup.string().nullable(),
  lastName: Yup.string().required('Required Field'),
  gender: Yup.string().required('Required Field'),
  dateOfBirth: Yup.string().required('Required Field'),
  language: Yup.string().required('Required Field'),
  secondaryLanguage: Yup.string().nullable(),

  // Profile fields
  beneficiaryCategory: Yup.string().nullable(),
  beneficiaryCode: Yup.string().nullable(),
  hyConnectId: Yup.string().nullable(),
  enrollmentDate: Yup.date().nullable(),
  createdAt: Yup.string().nullable(),

  // Sponsorship types (array)
  sponsorshipTypes: Yup.array(),

  location: Yup.object().shape({
    city: Yup.string().required('Required Field'),
    country: Yup.string().required('Required Field')
  }),

  healthCondition: Yup.string().required('Required Field'),
  healthNotes: Yup.string().nullable(),

  // Health fields
  medicalNotes: Yup.string().nullable(),
  medicalAssessedDate: Yup.date().nullable(),
  medicalDocuments: Yup.mixed().nullable(),

  guardian: Yup.object().shape({
    firstName: Yup.string().nullable(),
    middleName: Yup.string().nullable(),
    lastName: Yup.string().nullable(),

    email: Yup.string().email('Invalid Email').nullable(),
    phone: Yup.string().nullable(),
    address: Yup.string().nullable(),

    relationship: Yup.string().nullable(),

    occupation: Yup.string().nullable(),
    monthlyIncomeRange: Yup.string().nullable(),
    notes: Yup.string().nullable()
  }),

  inspiration: Yup.string().nullable(),
  hobbies: Yup.string().nullable(),
  initialJuz: Yup.string().nullable(),

  sponsorship: Yup.object().shape({
    statusId: Yup.string().nullable(),
    priorityId: Yup.string().nullable()
  }),

  // Status/management fields
  assignedStaffId: Yup.string().nullable(),
  caseNotes: Yup.string().nullable(),
  createdBy: Yup.string().nullable()
});
